export function delay(timeout) {
  return function(x) {
    return new Promise(resolve => setTimeout(() => resolve(x), timeout));
  };
}

export function DelayFor(timeout) {
  return Promise.resolve()
                .then(delay(timeout));
}